<template>
  <DemoForm :formData="data" :func="funcType" :isUpdate="isUpdate" @submitData="submitData($event)" />
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import DemoForm from '@/components/WelcomeSettings/DemoForm'

export default {
  name: 'welcome-demo-create',
  components: {DemoForm},
  mixins: [Error],
  data () {
    return {
      data: {
        name: '',
        code: '',
        sortId: 1,
        desc: '',
        ismd: true
      },
      funcType: '创建',
      isUpdate: false
    }
  },
  created () {},
  methods: {
    submitData (data) {
      api.createData(this, api.getWelcomeDemoCreate(this.$route.params.serviceCode), data, 'welcome-demo-list')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DemoCreate.vue?3b635a3d